import { useState, useEffect } from "react"
import { Button } from "primereact/button"
import { Card } from "primereact/card"
import { Globe, Sun, Moon, Sunrise } from "lucide-react"
import { addDays, format, isAfter, setHours, setMinutes } from "date-fns"
import { fetchAvailableSlots } from "./api/booking"


export function DatePicker({ onSelect, categoryId, config }) {
  const [selectedDate, setSelectedDate] = useState(null)
  const [availableSlots, setAvailableSlots] = useState([])
  const [isLoading, setIsLoading] = useState(false)
  const timezone = "Asia/Kolkata"

  // Get current date and time
  const now = new Date()
  const isPastFivePM = isAfter(now, setHours(setMinutes(now, 0), 17))

  // Generate available dates
  const availableDates = Array.from({ length: 5 }).map((_, index) => {
    const date = addDays(now, isPastFivePM ? index + 1 : index)
    return date
  })

  useEffect(() => {
    const loadSlots = async () => {
      if (selectedDate) {
        setIsLoading(true)
        try {
          const slots = await fetchAvailableSlots(config.PY_API_URL, format(selectedDate, "yyyy-MM-dd"), categoryId)
          setAvailableSlots(slots.data)
        } catch (error) {
          console.error("Failed to fetch slots:", error)
        } finally {
          setIsLoading(false)
        }
      }
    }

    loadSlots()
  }, [selectedDate, categoryId])

  const getPeriodStyles = (period) => {
    switch (period) {
      case "Morning":
        return "bg-blue-100 text-amber-600"
      case "Afternoon":
        return "bg-orange-100 text-orange-600"
      case "Evening":
        return "bg-indigo-100 text-indigo-600"
      default:
        return "bg-gray-100 text-gray-600"
    }
  }

  const getPeriodIcon = (period) => {
    switch (period) {
      case "Morning":
        return <Sunrise className="w-8 h-8" />
      case "Afternoon":
        return <Sun className="w-8 h-8" />
      case "Evening":
        return <Moon className="w-8 h-8" />
      default:
        return null
    }
  }

  return (
    <div className="space-y-6">
      {/* Header Section */}
      <div className="flex items-center justify-between  p-0 rounded-lg">
        <h3 className="text-lg font-semibold mr-2">Select Date & Time</h3>
        <div className="flex items-center gap-2 text-sm">
          <Globe className="w-4 h-4" style={{color: "#6466f1"}} />
          <span className="mt-0">{timezone}</span>
        </div>
      </div>

      {/* Selected Slot Details */}
      {/* {selectedDate && (
        <div className="flex items-center gap-4 p-4">
          <Card className="flex-1 p-4">
            <h4 className="font-semibold">Selected Date:</h4>
            <p>{format(selectedDate, "EEEE, MMM d, yyyy")}</p>
            <Button label="Edit" className="p-button-text mt-2" onClick={() => setSelectedDate(null)} />
          </Card>
        </div>
      )} */}

      {/* Date Selection */}
      <div className="grid grid-cols-5 gap-2 mt-0 ml-0 mb-3">
        {availableDates.map((date) => (
          <Button
            key={date.toISOString()}
            // label={format(date, "d")}
            // className={`flex flex-col h-auto py-3 ${selectedDate?.toDateString() === date.toDateString() ? "p-button-primary" : "p-button-outlined"}`}
            onClick={() => setSelectedDate(date)}
            style={{
              padding: "0px",
              height: "50px!important"
            }}
          >
            {/* <span className="text-sm font-normal">{format(date, "EEE")}</span> */}
            <div style={{height: "19px", width: "82px", fontSize: "22px"}}>{format(date, "d")}</div>
            {/* <br></br> */}
            <div className="text-sm font-normal">{format(date, "MMM")}</div>
          </Button>
        ))}
      </div>

      {/* Time Slots */}
      {isLoading ? (
        <div className="text-center py-4">Loading available slots...</div>
      ) : (
        selectedDate && (
          <div className="space-y-6">
            {["Morning", "Afternoon", "Evening"].map((period) => {
              const slots = availableSlots.filter((slot) => slot.period === period)

              if (slots.length === 0) return null

              return (
                <div className="grid m-0" key={period}>
                  <h4 className="text-sm font-medium mb-3 flex items-center gap-2">
                    <span style={{textAlign: 'center',borderRadius: '10px'}} className={`p-2 rounded-lg ${getPeriodStyles(period)}`}>{getPeriodIcon(period)}</span>
                    <span className="mt-3">{period}</span>
                  </h4>
                  <div className="col-12 md:col-12 lg:col-12" style={{padding: "0px"}}>
                    {slots.map((slot) => (
                      <Button
                        style={{padding: "10px",
                          height: "46px",
                          margin: "0px",
                          width: "100px",
                          paddingTop: "0px", marginRight: "10px", marginBottom: "10px"}}
                        key={slot.id}
                        label={slot.time}
                        className={`col-12 md:col-6 lg:col-3  ${slot.isBooked ? "opacity-50 cursor-not-allowed" : "p-button-outlined"}`}
                        disabled={slot.is_booked}
                        onClick={() =>
                          onSelect({
                            date: selectedDate,
                            time: slot.time,
                            slotId: slot.id,
                            timezone,
                          })
                        }
                      />
                    ))}
                  </div>
                </div>
              )
            })}
          </div>
        )
      )}
    </div>
  )
}
